import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Link } from "@reach/router";
import { makeStyles } from "@material-ui/styles";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import {
  IconUsers,
  IconLock,
  IconTicket,
  IconHome,
  IconX,
} from "@tabler/icons-react";

import { AppContext, TOGGLE_MENU } from "../context";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "350px",
    "@media(max-width: 576px)": {
      width: "100%",
    },
  },
  closeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "8px",
  },
  closeButton: {
    padding: "8px",
  },
  icon: {
    color: theme.app.labelColor,
  },
}));

const Menu = (props) => {
  const { config, language } = useSelector((state) => ({
    language: state.language,
    config: state.infrastructure.config,
  }));
  const classes = useStyles();
  const { ctx: state, dispatch } = useContext(AppContext);
  const toggleMenu = () => dispatch({ type: TOGGLE_MENU });
  const labelMenu = state.menuOpen ? language.CloseMenu : language.OpenMenu;
  return (
    <Drawer
      classes={{ paper: classes.paper }}
      open={state.menuOpen}
      onClose={toggleMenu}
    >
      <div className={classes.closeContainer}>
        <IconButton
          className={classes.closeButton}
          onClick={toggleMenu}
          aria-label={labelMenu}
        >
          <IconX />
        </IconButton>
      </div>
      <List>
        <ListItem
          button
          component={Link}
          to={`${process.env.PUBLIC_URL}/`}
          onClick={toggleMenu}
        >
          <ListItemIcon className={classes.icon}>{<IconHome />}</ListItemIcon>
          <ListItemText primary={language.Nav && language.Nav.Home} />
        </ListItem>
        <Divider />
        {config.registerMember && (
          <ListItem
            button
            component={Link}
            to={`${process.env.PUBLIC_URL}/registermember`}
            onClick={toggleMenu}
          >
            <ListItemIcon className={classes.icon}>
              {<IconUsers />}
            </ListItemIcon>
            <ListItemText
              primary={language.Nav && language.Nav.Register_Member}
            />
          </ListItem>
        )}
        {config.registerTicket && (
          <ListItem
            button
            component={Link}
            to={`${process.env.PUBLIC_URL}/registerticket`}
            onClick={toggleMenu}
          >
            <ListItemIcon className={classes.icon}>
              {<IconTicket />}
            </ListItemIcon>
            <ListItemText
              primary={language.Nav && language.Nav.Register_Ticket}
            />
          </ListItem>
        )}
        {!config.hideNewPassword && (
          <ListItem
            button
            component={Link}
            to={`${process.env.PUBLIC_URL}/requestpassword`}
            onClick={toggleMenu}
          >
            <ListItemIcon className={classes.icon}>{<IconLock />}</ListItemIcon>
            <ListItemText
              primary={language.Nav && language.Nav.Request_Password}
            />
          </ListItem>
        )}
      </List>
    </Drawer>
  );
};

export default Menu;
